import { updateGridQuery } from '@bingads-webui-campaign/summary-grid-helper';
import projectionGrid from 'projection-grid';
import { columnChooserPlugin } from '@bingads-webui-campaign/projection-grid-column-chooser';
import { inlineDownloadWithoutFilterstateAndSegmentPlugin } from '@bingads-webui-campaign/projection-grid-inline-download';
import { assistedSelectionPlugin } from '@bingads-webui/projection-grid-assisted-selection';
import { editablePlugin } from '@bingads-webui-campaign/projection-grid-editable';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { toolbarPlugin } from '@bingads-webui/projection-grid-toolbar';
import { paginationPlugin } from '@bingads-webui/projection-grid-pagination';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';
import { inlineErrorPlugin } from '@bingads-webui/projection-grid-inline-error';
import { aggregatedRowsPluginBuilder } from '@bingads-webui-campaign/pgrid-aggregated-rows';
import { performanceLogPlugin } from '@bingads-webui-campaign/pgrid-performance-log';
import { jsdataRawDataPlugin } from '@bingads-webui-campaign/projection-grid-js-data-raw-data';
import { crossPageSelectAllPlugin } from '@bingads-webui/projection-grid-cross-page-select-all';
import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { ProductGroupsGridConfig } from './common/view/product-groups-grid-config';
import AbstractProductGroupsView from './abstract-product-groups-grid';

class FlattenProductGroupsView extends AbstractProductGroupsView {
  initialize(options) {
    this.isTreeView = false;
    super.initialize(options);
  }

  getGridConfig() {
    return new ProductGroupsGridConfig({
      deps: this.deps,
      view: this,
      isTreeView: this.isTreeView,
      dataSource: this.gridParameters.dataSource,
      onTogglePillClicked: this.callbacks.onTogglePillClicked,
    });
  }

  initializeGridFactory() {
    return projectionGrid
      .factory({ vnext: true })
      .use(jsdataRawDataPlugin)
      .use(paginationPlugin)
      .use(crossPageSelectAllPlugin)
      .use(performanceLogPlugin)
      .use(dateFilterPlugin)
      // .use(this.dateFilterRefreshPlugin)
      .use(toolbarPlugin)
      .use(columnChooserPlugin)
      .use(editablePlugin)
      .use(assistedSelectionPlugin)
      .use(inlineErrorPlugin({
        errorIconClasses: ['grid-error', 'spritedimage'],
      }))
      .use(uiBlockerPlugin)
      .use(placeholderPlugin)
      .use(inlineDownloadWithoutFilterstateAndSegmentPlugin)
      .use(a11yPlugin)
      .use(aggregatedRowsPluginBuilder({
        i18n: this.deps.i18n,
        keys: {
          overallI18nKey: 'ProductGroupGrid_Total',
          filteredI18nKey: 'ProductGroupGrid_Filtered_Total',
        },
        permissions: this.deps.config.get('Permissions'),
        filterService: this.filterService,
        customConfig: {
          showSearchRow: false,
          showAudienceRow: false,
          showDeletedRow: false,
        },
      }));
  }

  renderTrunk() {
    // TODO: Update FilterService to include fetchWaterfallFilterPromises in p$Initialized
    // The issue here is that if refreshWaterfallFilters is called, initializeCombinedFilterPromise would
    // still be resolved but the waterfall filter data is not ready.

    // bluebird Promise.all behaves differently from native Promise.all
    // eslint-disable-next-line no-restricted-globals
    Promise.all([
      this.filterService.initializeCombinedFilterPromise,
      ...(this.filterService.fetchWaterfallFilterPromises || []),
    ]).then(() => {
      updateGridQuery(
        this.grid.gridView,
        this.filterService.getCombinedFilter(), true
      );
    });
    super.renderTrunk();
  }

  get className() { return 'product-groups-list-grid'; }
}

export default FlattenProductGroupsView;
